module.exports = __webpack_public_path__ + "static/media/instagram-square-brands.a4bfd613.svg";